import { Component, input } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { RegionItemDto } from '@artemis-software/wr-api';
import { currentTenantId } from '@/utils/admin-utils';

@Component({
  standalone: false,
  selector: 'wr-region-dashboard-page',
  templateUrl: './region-dashboard-page.component.html',
  styleUrls: ['./region-dashboard-page.component.scss'],
})
export class RegionDashboardPageComponent {

  currentTenantId = currentTenantId();
  readonly region = input.required<RegionItemDto>();

  form!: FormGroup;

  selectedRegion?: RegionItemDto;

  onRegionSelected(region: RegionItemDto): void {
    this.selectedRegion = region;
  }

}
